<script>
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import uniqueId from "lodash/uniqueId";
import DeliveryUnitTemplate from "@/components/tables/finance-template-deliveryUnit.vue";
import Treeselect from "@riophae/vue-treeselect";
export default {
  components: {
    DeliveryUnitTemplate,
    Treeselect,
    // DeliveryUnitTemplate: () =>
    //   import(
    //     /* webpackPrefetch: true */ "@/components/tables/finance-template-deliveryUnit.vue"
    //   ),
    // Treeselect: () => import(/* webpackPrefetch: true */ "@riophae/vue-treeselect"),
  },
  props: {
    objectOfExpenditures: null,
    tableBusy: null,
    template: null,
    prexc: null,
  },
  data() {
    return {
      fields: [
        {
          key: "actions",
          label: " ",
          tdClass: "align-middle",
        },
        {
          key: "uacs",
          label: "UACS",
          sortable: true,
          tdClass: "align-middle",
        },
        {
          key: "account",
          label: "Account name",
          sortable: true,
          tdClass: "align-middle",
        },
        {
          key: "group",
          label: "Account group",
          sortable: true,
          tdClass: "align-middle",
        },
        {
          key: "allocated",
          label: "Allocated",
          sortable: true,
          tdClass: "text-warning align-middle",
        },
        {
          key: "modify",
          label: " ",
          tdClass: "col-md-1 align-middle text-center",
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 25,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "account",
      sortDesc: false,
      addModal: false,
      availableDeliveryUnits: [],
      availableUnitsConsist: "LEAF_PRIORITY",
      newData: [],
      selectedOE: null,
      duLoading: false,
      availableDULoading: false,
    };
  },
  methods: {
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    checkExpiry(data) {
      return new Date() < new Date(data) ? true : false;
    },
    formatCurrency(data) {
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "PHP",
      }).format(data);
    },

    deleteItem(row) {
      if (row.allocated > 0) {
        return this.showToast(
          "Cannot delete this item because it has been allocated.",
          "error"
        );
      }
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          const item = JSON.parse(JSON.stringify(row));
          this.$store
            .dispatch("financeTemplate/deleteObjectOfExpenditure", row.id)
            .then(() => {
              this.$emit("deleteOE", item);
              this.showToast("Item deleted successfully.", "success");
            })
            .catch(() => {
              this.showToast("Error deleting item.", "error");
            });
        }
      });
    },
    filterTable(row, filter) {
      if (row.account.accountName.toLowerCase().includes(filter)) {
        return true;
      } else {
        return false;
      }
    },
    fetchDU(id) {
      this.$store
        .dispatch("financeTemplate/getBudgetItemsByOE", id)
        .then((response) => {
          this.objectOfExpenditures.find(
            (item) => item.id === id
          ).deliveryUnits = response.data.map((item) => ({
            ...item,
            amount: item.amount.toString(),
          }));
          this.duLoading = false;
        })
        .catch(() => {
          this.duLoading = false;
          this.showToast("Error fetching budget items", "error");
        });
    },
    showDtls(row) {
      row.item.rotateChevy = !row.item.rotateChevy;
      if (row.item.showDetails) {
        row.toggleDetails();
        row.item.showDetails = !row.item.showDetails;
      } else {
        this.duLoading = true;
        row.toggleDetails();
        setTimeout(() => {
          this.fetchDU(row.item.id);
        }, 1000);
        row.item.showDetails = !row.item.showDetails;
      }
    },
    addNew(id) {
      this.addModal = true;
      this.availableDULoading = true;
      this.selectedOE = id;
      this.$store
        .dispatch("financeTemplate/getAvailableDeliveryUnits", id)
        .then((response) => {
          //filter response.data that are listed in this.$store.state.decrypt.campusAccessList()
          const campusAccess = this.$store.state.decrypt
            .campusAccessList()
            .map((item) => item.Id);
          // const campuses = response.data.filter(({ id }) => {
          //   return campusAccess.includes(id);
          // });
          const campuses = response.data.filter(
            (item) => item.id === this.$store.state.data.selectedCampus.id
          );

          this.availableDeliveryUnits = campuses.map((item) => ({
            id: uniqueId("campus_"),
            label: item.campusName,
            children: item.offices.map((office) => ({
              id: uniqueId("office"),
              label: office.name,
              children: office.deliveryUnits.map((du) => ({
                id: du.id,
                label: du.name,
              })),
            })),
          }));
          this.availableDULoading = false;
        })
        .catch((e) => {
          this.availableDULoading = false;
          this.addModal = false;
          this.showToast("Something went wrong. Cannot fetch available PREXCs", "error");
        });
    },
    saveUnits() {
      const data = this.newData.map((item) => ({
        financeTemplateObjectOfExpenditureId: this.selectedOE,
        deliveryUnitId: item,
        amount: 0,
      }));
      this.$store
        .dispatch("financeTemplate/createMultipleBudgetItem", data)
        .then(() => {
          this.fetchDU(this.selectedOE);
          this.addModal = false;
          this.newData = [];
          this.showToast("Successfully added budget items", "success");
        })
        .catch(() => {
          this.showToast("Something went wrong. Cannot save Budget Items", "error");
        });
    },
    clear() {
      this.newData = [];
      this.addModal = false;
    },
    updatePrexc(record) {
      this.$emit("updatePrexc", record);
    },
  },
  computed: {
    rows() {
      return this.objectOfExpenditures.length;
    },
  },
};
</script>

<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <div id="tickets-table_length" class="dataTables_length">
          <label class="d-inline-flex align-items-center">
            Show&nbsp;
            <b-form-select
              class="form-select form-select-sm mx-1"
              v-model="perPage"
              size="sm"
              :options="pageOptions"
            >
            </b-form-select
            >&nbsp;entries
          </label>
        </div>
      </div>
      <!-- Search -->
      <div class="col-md-6">
        <div id="tickets-table_filter" class="dataTables_filter text-md-end">
          <label class="d-inline-flex align-items-center">
            Search:
            <b-form-input
              v-model="filter"
              type="search"
              placeholder="Search account name..."
              class="form-control form-control-sm ms-2"
            ></b-form-input>
          </label>
        </div>
      </div>
      <!-- End search -->
    </div>
    <div class="custom-table-responsive mb-0">
      <b-table
        class="datatable table-sm"
        :items="objectOfExpenditures"
        :fields="fields"
        responsive="sm"
        :per-page="perPage"
        :current-page="currentPage"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :filter="filter"
        :filter-function="filterTable"
        :busy="tableBusy"
        @filtered="onFiltered"
        bordered
        outlined
        striped
        show-empty
        selected-variant="success"
      >
        <template #empty="scope">
          <div class="text-center">{{ scope.emptyText }}</div>
        </template>
        <template #table-busy>
          <div class="d-flex justify-content-center align-items-center">
            <div class="preloader-component me-2">
              <div class="status">
                <div class="spinner-chase w-20px h-20px">
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                </div>
              </div>
            </div>
            <strong>Loading...</strong>
          </div>
        </template>
        <template #cell(uacs)="row">
          {{ row.item.account.uacs }}
        </template>
        <template #cell(allocated)="row">
          {{
            row.item.allocated ? formatCurrency(row.item.allocated) : formatCurrency(0)
          }}
        </template>
        <template #cell(account)="row">
          {{ row.item.account.accountName }}
        </template>
        <template #cell(group)="row">
          {{ row.item.account.accountGroup.groupName }}
        </template>
        <template #cell(actions)="row">
          <div
            class="d-flex align-items-center justify-content-center"
            @click="showDtls(row)"
          >
            <i
              class="bx bx-chevron-right rotate font-size-16 cursor-pointer"
              :class="{
                'rotate-90': row.item.rotateChevy,
              }"
            ></i>
          </div>
        </template>
        <template #cell(modify)="row">
          <b-button
            variant="link"
            @click="deleteItem(row.item)"
            class="text-danger font-size-18"
            ><i class="mdi mdi-trash-can-outline"></i
          ></b-button>
        </template>
        <template #row-details="row">
          <transition name="max-height">
            <div class="card border border-warning" v-if="row.item.showDetails">
              <div class="row">
                <div class="col-md-6">
                  <div class="card-header bg-transparent border-success mt-2">
                    <h5 class="my-0 text-warning">
                      <i class="bx bx-buildings me-3"></i>Delivery Units
                    </h5>
                  </div>
                </div>
                <div class="col-md-6 text-end">
                  <b-button
                    class="mt-3 me-3"
                    size="sm"
                    variant="primary"
                    @click="addNew(row.item.id)"
                  >
                    <i class="bx bx-plus"></i> Add New
                  </b-button>
                </div>
              </div>

              <div class="card-body">
                <DeliveryUnitTemplate
                  :deliveryUnits="row.item.deliveryUnits"
                  :tableBusy="duLoading"
                  :oe="row.item.id"
                  :template="template"
                  :prexc="prexc"
                  @refresh="fetchDU"
                  @updatePrexc="updatePrexc"
                />
              </div>
            </div>
          </transition>
        </template>
      </b-table>
    </div>
    <div class="row">
      <div class="col">
        <div class="dataTables_paginate paging_simple_numbers float-end">
          <ul class="pagination pagination-rounded mb-0">
            <!-- pagination -->
            <b-pagination
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
            ></b-pagination>
          </ul>
        </div>
      </div>
    </div>

    <b-modal
      v-model="addModal"
      size="lg"
      title="Select Delivery Units"
      no-close-on-backdrop
    >
      <div v-if="availableDULoading">
        <b-spinner small></b-spinner>
        <span class="ms-2">Loading...</span>
      </div>
      <div class="row" v-else>
        <treeselect
          :multiple="true"
          :options="availableDeliveryUnits"
          :value-consists-of="availableUnitsConsist"
          :limit="5"
          :max-height="300"
          v-model="newData"
          :clearOnSelect="true"
        />
      </div>
      <template #modal-footer>
        <b-button variant="primary" @click="saveUnits"> Save </b-button>
        <b-button variant="link" @click="clear"> Close </b-button>
      </template>
    </b-modal>
  </div>
</template>
